export default __webpack_public_path__ + "static/media/bin.9d165142.svg";